import {Injectable} from '@angular/core';
import {JwtService} from 'mclane-webauth-lib';

export enum AppStorage {
    preferred_username = 'preferred_username',
    name = 'name',
    email_verified = 'email_verified',
    given_name = 'given_name',
    family_name = 'family_name',
    email = 'email',
    token = 'token',
    edit_item_maint = 'edit_item_maint',
    item_sequence = 'item_sequence',
    store_selected = 'store_selected',
    chain = 'chain',
    customer_id = 'customer_id',
    customer_number = 'customer_number',
    src_system = 'src_system',
    trackingId = 'trackingId',
    eventStatus = 'eventStatus',
    selectedProfileTab = 'selectedProfileTab',
    initGoogleAnalytics = 'initGoogleAnalytics',
    order_changes_saved = 'order_changes_saved',
    profile_changes_saved = 'profile_changes_saved',
    profile_category_changes_saved = 'profile_category_changes_saved',
    cal_event = 'cal_event',
    application_mode = 'application_mode',
    application_target = 'application_target',
    roles = 'roles',
    ftpRct = 'ftpRct',
    fileUpload = 'fileUpload'
}

@Injectable({
    providedIn: 'root'
})
export class ApplicationSettingsHelper {
    constructor(public jwtService: JwtService) {
    }

    private _roles: any;

    get roles(): any {
        return this._roles;
    }

    set roles(value: any) {
        this._roles = value;
    }

    setTrackingId(trackingId: string) {
        localStorage.setItem(AppStorage.trackingId, trackingId);
    }

    getTrackingId(): string {
        return localStorage.getItem(AppStorage.trackingId);
    }

    setRoles(roles: any) {
        // console.log('User roles coming after login from keycloak for application-settings-helper.ts :', roles);
        // localStorage.setItem(AppStorage.roles, roles);
    }

    getRoles() {
        // return localStorage.getItem(AppStorage.roles);
        return;
    }

    setName(name: string) {
        localStorage.setItem(AppStorage.name, name);
    }

    getName(): string {
        return localStorage.getItem(AppStorage.name);
    }

    setToken(token: string) {
    }

    getToken(): string {
        return;
    }

    setApplicationMode(mode: string) {
        localStorage.setItem(AppStorage.application_mode, mode);
    }

    getApplicationMode(): string {
        return localStorage.getItem(AppStorage.application_mode);
    }

    setApplicationTarget(mode: string) {
        localStorage.setItem(AppStorage.application_target, mode);
    }

    getApplicationTarget(): string {
        return localStorage.getItem(AppStorage.application_target);
    }

    setEventStatus(eventStatus: string) {
        localStorage.setItem(AppStorage.eventStatus, eventStatus);
    }

    setEvent(eventStatus: string) {
        localStorage.setItem(AppStorage.cal_event, eventStatus);
    }

    getEvent() {
        return localStorage.getItem(AppStorage.cal_event);
    }

    getEventStatus(): string {
        return localStorage.getItem(AppStorage.eventStatus);
    }

    setChain(chain: string) {
        localStorage.setItem(AppStorage.chain, chain);
    }

    setCustomerId(customerId: string) {
        localStorage.setItem(AppStorage.customer_id, customerId);
    }

    setCustomerNumber(customerNumber: string) {
        localStorage.setItem(AppStorage.customer_number, customerNumber);
    }

    setSrcSystem(srcSystem: string) {
        localStorage.setItem(AppStorage.src_system, srcSystem);
    }

    getChain(): string {
        return localStorage.getItem(AppStorage.chain);
    }

    getCustomerId(): string {
        return localStorage.getItem(AppStorage.customer_id);
    }

    getCustomerNumber(): string {
        return localStorage.getItem(AppStorage.customer_number);
    }

    getSrcSystem(): string {
        return localStorage.getItem(AppStorage.src_system);
    }

    setFtpRct(fptRct: string) {
        localStorage.setItem(AppStorage.ftpRct, fptRct);
    }

    getFtpRct(): string {
        return localStorage.getItem(AppStorage.ftpRct);
    }

    setFileUpload(fileUpload: string) {
        localStorage.setItem(AppStorage.fileUpload, fileUpload);
    }

    getFileUpload(): string {
        return localStorage.getItem(AppStorage.fileUpload);
    }


    setSelectedProfileTab(selectedProfileTab: string) {
        localStorage.setItem(AppStorage.selectedProfileTab, selectedProfileTab);
    }

    getSelectedProfileTab(): string {
        return localStorage.getItem(AppStorage.selectedProfileTab);
    }

    setStoreSelected(storeSelected: string) {
    }

    getStoreSelected(): string {
        return localStorage.getItem(AppStorage.store_selected);
    }

    setInitGoogleAnalytics(initGoogleAnalytics: string) {
        localStorage.setItem(AppStorage.initGoogleAnalytics, initGoogleAnalytics);
    }

    getInitGoogleAnalytics(): string {
        return localStorage.getItem(AppStorage.initGoogleAnalytics);
    }

    setOrderChangesSaved(orderChangesSaved: boolean) {
    }

    getOrderChangesSaved(): boolean {
        return;
    }

    setProfileChangesSaved(profileChangesSaved: boolean) {
    }

    getProfileChangesSaved(): boolean {
        return;
    }

    setProfileCategoryChangesSaved(profileCategoryChangesSaved: boolean) {
    }

    getProfileCategoryChangesSaved(): boolean {
        return;
    }

    setPreferredUserName(preferred_name: string) {
    }

    getPreferredUserName(): string {
        return this.jwtService.preferred_username;
    }

    setOrderStatus(orderStatus: string) {
        return;
    }

    clearStorage() {
        localStorage.clear();
    }
}
